// src/components/layout/Screensaver.tsx
import React, { useState, useEffect } from 'react';
import '../../css/screensaver.css'; // Make sure to import the new CSS

interface ScreensaverProps {
  onDismiss: () => void;
  tagline?: string;
}

const Screensaver: React.FC<ScreensaverProps> = ({
  onDismiss,
  tagline = 'Click or press any key to return',
}) => {
  const [time, setTime] = useState(new Date());
  // Removed: const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Add keydown listener for dismissal on any key press
  useEffect(() => {
    const handleKeyDown = () => {
        // Dismiss on any key press
        onDismiss();
    };
    
    // Add the listener to the whole window
    window.addEventListener('keydown', handleKeyDown);
    
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onDismiss]);
  
  // Removed: handleMouseMove function

  const formatTime = (date: Date): string => {
    return date.toLocaleTimeString('en-US', {
      hour12: true,
      hour: 'numeric',
      minute: '2-digit',
    }).replace(/ (AM|PM)/, ''); // Remove AM/PM from the main string
  };

  const formatSeconds = (date: Date): string => {
    return date.toLocaleTimeString('en-US', { second: '2-digit' });
  };
  
  const formatAmPm = (date: Date): string => {
    return date.toLocaleTimeString('en-US', { hour12: true, hour: 'numeric' }).slice(-2);
  }

  const formatDate = (date: Date): string => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div
      className="screensaver-overlay"
      onClick={onDismiss} // Dismiss on mouse click/tap
      // Removed: onMouseMove={handleMouseMove}
      title="Dismiss screensaver"
      // Added tabIndex to ensure it can receive focus and key events if needed, 
      // though the window listener should be sufficient.
      tabIndex={-1} 
    >
      {/* Removed: Interactive element that follows the mouse */}
      {/* <div 
        className="interactive-glow" 
        style={{ top: `${mousePos.y}px`, left: `${mousePos.x}px` }} 
      /> */}

      {/* Animated Blob Background */}
      <div className="screensaver-background">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      {/* Main Content */}
      <div className="screensaver-content">
        <div className="screensaver-time">
          <span>{formatTime(time)}</span>
          <span className="seconds-display">{formatSeconds(time)}</span>
          <span className="ampm-display">{formatAmPm(time)}</span>
        </div>
        <div className="screensaver-date">{formatDate(time)}</div>

        {/* Simple Tagline */}
        <div className="screensaver-tagline">
          <div className="status-indicator" />
          <p>{tagline}</p>
        </div>
      </div>
    </div>
  );
};

export default Screensaver;